import { cn } from "@volca/ui/lib/utils";
import type { MachineArt } from "./art/machine-art";

const SIZES = { 72: "size-18", 96: "size-24", 112: "size-28" } as const;

export type SmallMachineSize = keyof typeof SIZES;

interface SmallMachineProps {
  art: MachineArt;
  size?: SmallMachineSize;
  className?: string;
}

/**
 * A small, static isometric drawing for the corner of a record panel. It is
 * decorative and hidden from assistive technology, like `EmptyMachine`, and
 * follows light and dark through the same machine theme. It has no runtime
 * and no motion.
 *
 * Every drawing fits the same square, standing on its bottom edge: a wide van
 * and a tall clipboard take the same room and share a ground line, so no
 * record's mark looks bigger than another's.
 */
export const SmallMachine = ({
  art,
  size = 96,
  className,
}: SmallMachineProps) => (
  <svg
    className={cn("machine shrink-0", SIZES[size], className)}
    viewBox={art.viewBox}
    preserveAspectRatio="xMidYMax meet"
    aria-hidden
    focusable={false}
    data-small-machine=""
    dangerouslySetInnerHTML={{ __html: art.body }}
  />
);
